// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import { iconScalableStyles } from "@store/Themes/common/mixins/icon";
import { css } from "styled-components";

export type StatusColor = "success" | "warning" | "danger" | "info" | "neutral";

export const statusStyles = (color?: StatusColor, offset?: IconOffset) => {
    /* Store Custom Code - Start */
    const isInverted = color === "success" || color === "danger";
    /* Store Custom Code - End */

    return css`
        display: flex;
        align-items: center;
        padding: ${pxToRem(7.5, 12)};
        border-radius: ${pxToRem(16)}; /* Store Custom Code */

        ${({ theme }) => css`
            color: ${getColor(isInverted ? `${color}.light` : `${color}.contrast`)}; /* Store Custom Code */
            background-color: ${getColor(isInverted ? `${color}.contrast` : `${color}.light`)}; /* Store Custom Code */
            font-size: ${theme.design.typography.size.tiny};
            font-weight: ${theme.design.typography.weight.semibold}; /* Store Custom Code */
            line-height: ${theme.design.typography.lineHeight.small};

            /* Store Custom Code - Start */
            ${isInverted &&
            css`
                border-width: 1px;
                border-style: solid;
                border-color: ${getColor(`${color}.light`)};
            `};
            /* Store Custom Code - End */
        `}

        ${IconWrapper} {
            ${iconScalableStyles(pxToRem(20), offset)}
            overflow: visible;
            height: 0;
            /* Store Custom Code - Start */
            margin: ${pxToRem(0, 5, 0, -7)};
            color: ${getColor(isInverted ? `${color}.light` : `${color}.contrast`)};
            /* Store Custom Code - End */
        }
    `;
};
